import { render } from "./ValueChip.vue?vue&type=template&id=13afc76b"
import script from "./ValueChip.vue?vue&type=script&lang=js"
export * from "./ValueChip.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__